/* eslint-disable import/prefer-default-export */
// Remove eslint comment above if we add more actions (as expected)
// performanceComparisonChartActions
export function changeComparisonType(
  dashboard,
  scoreType,
  filterParamsQueryString,
  filterLocations
) {
  let apiUrl = "/reporting/performance-comparison/summary"

  // Append the filter parameters as the query string
  apiUrl += `${filterParamsQueryString}&scoreType=${scoreType}`

  if (filterLocations && filterLocations.length > 0) {
    return {
      type: `${dashboard}COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE`,
      payload: {
        request: {
          method: "PUT",
          url: apiUrl,
          data: { LocationIds: filterLocations },
        },
      },
    }
  }

  // Hits the API to load the data, then returns a Promise
  // (for callback-like functionality - e.g. to load other dashboards in the background)
  // Dashboard specific reducers then hook into the SUCCESS/FAIL action types
  // generated by redux-axios-middleware
  return {
    type: `${dashboard}COMPARISON_LINE_CHART_LOAD_COMPARISON_TYPE`,
    payload: {
      request: {
        url: apiUrl,
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/performanceComparisonChartActions.js